import React, { useState, useEffect } from "react";
import Header from "./../../components/Header";
import "./HallsOfAmenti.sass";
import Welcome from "./Welcome";
import Membership from "./Membership";
import Frendao from "./Frendao";
import HallTeam from "./HallTeam";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function HallsOfAmenti() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  const [headerBg, setHeaderBg] = useState(
    "linear-gradient(0deg, rgba(96, 86, 72, 0.5) 0%, rgba(96, 86, 72, 0.5) 100%), url(/images/faqs-mobile-bg.png)"
  );
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    if (windowDimensions.width < 576) {
      setHeaderBg(
        "linear-gradient(0deg, rgba(96, 86, 72, 0.5) 0%, rgba(96, 86, 72, 0.5) 100%), url(/images/faqs-mobile-bg.png)"
      );
    } else {
      setHeaderBg(
        "linear-gradient(0deg, rgba(108, 63, 0, 0.65) 0%, rgba(108, 63, 0, 0.65) 100%), url(/images/halls-bg.png)"
      );
    }

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [windowDimensions.width]);

  //const headerBg = "url(/images/halls-bg.png)";
  return (
    <div className="halls">
      <Header bg={headerBg} />
      <Welcome />
      <Membership />
      <Frendao />
      <HallTeam />
    </div>
  );
}
